import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import numeral from 'numeral';
import Highcharts from 'highcharts';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import HighchartsReact from 'highcharts-react-official';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// Components
// import GroupCard from '../../components/GroupCard';

// Actions
import { gameActions } from '../../actions';

import Header from '../../components/Header';
import { DebriefMenu } from './debrief_menu';
// import infoModal from '../../assets/info-modal-1.png';

NoDataToDisplay(Highcharts);

// INLINE COMPONENTS
const TotalLearningCurveChart = ({ data }) => {
  const chartOptions = {
    chart: {
      type: 'line',
      height: 500,
      backgroundColor: 'transparent',
    },
    credits: {
      enabled: false,
    },
    title: {
      // text: 'Learning Curve: All Tasks',
      text: '',
    },
    xAxis: {
      title: {
        text: 'N-th Loan Completed',
      },
      min: 1,
      tickInterval: 1,
      //   gridLineWidth: 1,
      labels: {
        formatter: function () {
          const ordinal =
            this.value === 1
              ? 'st'
              : this.value === 2
              ? 'nd'
              : this.value === 3
              ? 'rd'
              : 'th';
          return `${this.value}${ordinal}`;
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Sum of Processing Time (seconds)',
      },
      gridLineWidth: 1,
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      headerFormat:
        '<span style="font-size:12px">{point.key}{series.chart.axes[0].tickPositioner.ordinal}</span><br/>',
      pointFormat:
        '<span style="color:{series.color}">Average Total Time: </span>' +
        '<b>{point.y:.2f} seconds</b><br/>',
      formatter: function () {
        const ordinal =
          this.x === 1
            ? 'st'
            : this.x === 2
            ? 'nd'
            : this.x === 3
            ? 'rd'
            : 'th';
        return `<span style="font-size:12px">${
          this.x
        }${ordinal} Loan Completed</span><br/>
                <span style="color:${
                  this.series.color
                }">Average Total Time: </span>
                <b>${this.y.toFixed(2)} seconds</b><br/>`;
      },
    },
    series: [
      {
        name: 'Average Total Time',
        data: data,
      },
    ],
    noData: {
      style: {
        fontSize: '16px',
        color: '#666',
      },
      position: {
        align: 'center',
        verticalAlign: 'middle',
      },
    },
  };

  return (
    <div className='total-learning-curve-chart'>
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        containerProps={{ style: { height: '500px', width: '100%' } }}
      />
    </div>
  );
};

class DebriefLearningCurveTotal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: this.props.item || null,
    };
  }

  componentDidMount() {
    const { dispatch, match, game } = this.props;
    if (match.params.id && !game?.data?._id) {
      dispatch(gameActions.fetchGames(match.params.id));
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      item: newProps.item,
    });
  }

  render() {
    const { game } = this.props;
    const gameData = game.data;

    // Tasks list
    const tasksNames = [
      'front-ratio',
      'back-ratio',
      'loan-to-value',
      'risk-assessment',
      'decision',
    ];

    // Step 1: Get all decision items across all groups and sort by completion order
    const allDecisionItems = [];

    gameData?.groups?.forEach((group, groupIndex) => {
      const decisionItems =
        group?.items?.filter((item) => item.activity === 'decision') || [];
      decisionItems.forEach((item) => {
        allDecisionItems.push({
          ...item,
          groupIndex,
          groupId: group._id,
          groupName: group?.name || `Team ${groupIndex + 1}`,
        });
      });
    });

    // Sort decision items by created_at to get completion order
    allDecisionItems.sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return dateA - dateB;
    });

    // Step 2: Get unique loan applications in completion order
    const uniqueLoanApplications = [];
    const seenApplications = new Set();

    allDecisionItems.forEach((decisionItem) => {
      if (!seenApplications.has(decisionItem.application)) {
        seenApplications.add(decisionItem.application);
        uniqueLoanApplications.push(decisionItem.application);
      }
    });

    // Step 3: Calculate total learning curve data based on completion order
    const totalLearningCurveData = [];

    uniqueLoanApplications.forEach((loanId, orderIndex) => {
      const groupTotals = [];

      // For each group, calculate the total elapsed time for this loan across all tasks
      gameData?.groups?.forEach((group) => {
        let totalElapsedTime = 0;
        let hasData = false;

        // Sum elapsed time across all tasks for this loan in this group
        tasksNames.forEach((taskName) => {
          const taskItems =
            group?.items?.filter(
              (item) =>
                item.activity === taskName && item.application === loanId
            ) || [];

          taskItems.forEach((item) => {
            let elapsed = 0;

            // Calculate elapsed time (elapsed_time is in milliseconds, convert to seconds)
            if (item.elapsed_time) {
              elapsed = item.elapsed_time / 1000;
              hasData = true;
            } else if (item.created_at && item.started_at) {
              elapsed =
                (new Date(item.created_at) - new Date(item.started_at)) / 1000;
              hasData = true;
            }

            totalElapsedTime += elapsed;
          });
        });

        // Only include groups that have data for this loan
        if (hasData && totalElapsedTime > 0) {
          groupTotals.push(totalElapsedTime);
        }
      });

      // Calculate average total elapsed time for this loan across all groups
      if (groupTotals.length > 0) {
        const averageTotal =
          groupTotals.reduce((sum, time) => sum + time, 0) / groupTotals.length;
        // Use orderIndex + 1 as x-axis (1st completed loan, 2nd completed loan, etc.)
        totalLearningCurveData.push([orderIndex + 1, averageTotal]);
      }
    });

    return (
      <div>
        <Header />

        {/* <h2 className='mt-3 sec-title fs-3'>
          Learning Curve: All Tasks{' '}
          <small className='float-end'>
            <DebriefMenu
              game_id={game.data._id}
              location={this.props.location}
            />
          </small>
        </h2> */}

        <h2 className='d-flex mt-3 sec-title fs-3'>
          <span className='d-none d-xl-inline text-nowrap'>
            Learning Curve: All Tasks
          </span>
          {/* Display sub-menu on larger viewports */}
          <DebriefMenu
            className='small d-flex justify-content-between justify-content-xl-end align-items-center ms-xl-auto w-100'
            game_id={game.data._id}
            location={this.props.location}
          />
        </h2>

        <div className='row mt-3'>
          <div className='col-12 mb-3'>
            <p className='text-center'>
              This chart shows the average total elapsed time (sum of all task
              times) for each loan application in the order they were completed
              (based on decision submission order).
            </p>
          </div>

          {/* Statistics */}
          {/* <div className='col-12 mb-4'>
            <div className='row text-center'>
              <div className='col-md-3'>
                <div className='card border-primary'>
                  <div className='card-body'>
                    <h5 className='card-title text-primary'>Min Time</h5>
                    <p className='card-text fs-4 fw-bold'>
                      {minTime.toFixed(2)}s
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-md-3'>
                <div className='card border-success'>
                  <div className='card-body'>
                    <h5 className='card-title text-success'>Max Time</h5>
                    <p className='card-text fs-4 fw-bold'>
                      {maxTime.toFixed(2)}s
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-md-3'>
                <div className='card border-info'>
                  <div className='card-body'>
                    <h5 className='card-title text-info'>Average Time</h5>
                    <p className='card-text fs-4 fw-bold'>
                      {avgTime.toFixed(2)}s
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-md-3'>
                <div className='card border-warning'>
                  <div className='card-body'>
                    <h5 className='card-title text-warning'>Data Points</h5>
                    <p className='card-text fs-4 fw-bold'>
                      {validData.length}/49
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* CHART */}
          <div className='col-12'>
            <div className='mb-5 pt-3 shadow bg-white border'>
              <TotalLearningCurveChart data={totalLearningCurveData} />
            </div>
          </div>

          {/* Additional Info */}
          {/* <div className='col-12 mt-3'>
            <div className='alert alert-info'>
              <h6 className='alert-heading'>How to interpret this chart:</h6>
              <ul className='mb-0'>
                <li>
                  <strong>X-axis:</strong> Loan Application ID (1-49)
                </li>
                <li>
                  <strong>Y-axis:</strong> Average total elapsed time in seconds
                  (sum of front-ratio + back-ratio + loan-to-value +
                  risk-assessment + decision times)
                </li>
                <li>
                  <strong>Learning Effect:</strong> A downward trend indicates
                  teams are getting faster at processing loans over time
                </li>
                <li>
                  <strong>Missing Points:</strong> Some loans may not have data
                  if they weren't processed by any group
                </li>
              </ul>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { player, game } = state;
  return {
    game,
    player,
  };
}

export default connect(mapStateToProps)(DebriefLearningCurveTotal);
